import React from "react";
import Search from "./Search";
import ProvidersSlider from "./ProvidersSlider";
import ProvidersDropdown from "./ProvidersDropdown";
import FiltersSelected from "./FiltersSelected";
import CategoriesDropdown from "./CategoriesDropdown";
import { Button } from "@mui/material";
import { useAtom } from "jotai";
import { gridSizeAtom, sortOrderAtom } from "../state/games";
import DisplayMICon from "@icons/displayM.svg";
import DisplayLICon from "@icons/displayL.svg";
import DisplaySICon from "@icons/displayS.svg";
import SortIcon from "@icons/sort-g.svg";
import Icon from "./Icon";

const Filters = () => {
    const [gridSize, setGridSize] = useAtom(gridSizeAtom);
    const [sortOrder, setSortOrder] = useAtom(sortOrderAtom);
    return (
        <>
            <div className="filters">
                <Search />
                <ProvidersSlider />
            </div>

            <div className="toolbar-wrapper">
                <div className="dropdowns">
                    <CategoriesDropdown />
                    <ProvidersDropdown />
                </div>

                <div className="toolbar">
                    <Button
                        className={gridSize == "xl" ? "active" : ""}
                        size="small"
                        onClick={() => setGridSize("xl")}
                    >
                        <Icon icon={DisplayLICon} />
                    </Button>
                    <Button
                        className={gridSize == "md" ? "active" : ""}
                        size="small"
                        onClick={() => setGridSize("md")}
                    >
                        <Icon icon={DisplayMICon} />
                    </Button>
                    <Button
                        className={gridSize == "xs" ? "active" : ""}
                        size="small"
                        onClick={() => setGridSize("xs")}
                    >
                        <Icon icon={DisplaySICon} />
                    </Button>
                    <Button
                        className={sortOrder == "asc" ? "active" : ""}
                        size="small"
                        onClick={() => setSortOrder(sortOrder === "asc" ? "" : "asc")}
                    >
                        <Icon icon={SortIcon} />
                    </Button>
                </div>
            </div>
            <div className="filters selected">
                <FiltersSelected />
            </div>
        </>
    );
};

export default Filters;
